import React from 'react';
export function AnnouncementBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-primary text-white py-2.5 overflow-hidden shadow-md" data-id="element-16">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-17">
        {[1, 2, 3, 4].map(i => <span key={i} className="inline-block px-8 text-sm font-medium" data-id="element-18">
            🚨 PRECIO DE LANZAMIENTO — PUEDE SUBIR EN CUALQUIER MOMENTO
            &nbsp;•&nbsp;
          </span>)}
      </div>
    </div>;
}